import React, { useState, useMemo } from "react";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Invoice } from "../../models/Invoice";
import { StyledYearFilterBar } from "./YearFilterBar.styled";

interface YearFilterBarProps {
  invoices: Invoice[];
  onYearChange: (year: string | "Totaal") => void;
}

export const YearFilterBar = ({ invoices, onYearChange }: YearFilterBarProps) => {
  const [selectedYear, setSelectedYear] = useState<number | "Totaal">(2025);

  const years = useMemo(() => {
    const uniqueYears = Array.from(
      new Set(invoices.map((inv) => new Date(inv.invoiceDate).getFullYear()))
    ).sort((a, b) => b - a);
    return uniqueYears;
  }, [invoices]);

  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newYear: number | "Totaal" | null
  ) => {
    if (newYear !== null) {
      setSelectedYear(newYear);
      onYearChange(newYear.toString());
    }
  };

  return (
    <StyledYearFilterBar>
    <ToggleButtonGroup
      value={selectedYear}
      exclusive
      onChange={handleChange}
      color="primary"
      className="toggleButtonGroup"
    >
      <ToggleButton value="Totaal" key="Totaal" className="toggleButton">
        <Typography variant="h4">Totaal</Typography>
      </ToggleButton>
      {years.map((year) => (
        <ToggleButton key={year} value={year} className="toggleButton">
          <Typography variant="h4">{year}</Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    </StyledYearFilterBar>
  );
};